import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    container: {
        margin: '8px 0',
        padding: '12px',
        minHeight: '150px',
        position: 'relative'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    },
    title: {
        fontWeight: 'bold'
    },
    subtitle: {
        fontSize: 14
    },
    iconHeader: {
        position: 'absolute',
        right: 0,
        fontWeight: 'bold',
        color: 'green'
    }
}))